export const LOCALE_COOKIE_NAME = 'locale';
// Parent of the ATBase, IIB and 1PIDP hosts, so one cookie reaches all three
const SHARED_COOKIE_DOMAIN = 'ihm.amazon.dev';
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;

export function readLocaleCookie(): string | null {
    const prefix = `${LOCALE_COOKIE_NAME}=`;
    const match = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(prefix));
    return match ? decodeURIComponent(match.substring(prefix.length)) : null;
}

export function writeLocaleCookie(locale: string): void {
    const { hostname, protocol } = window.location;
    const attributes = [`${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)}`, 'Path=/', `Max-Age=${ONE_YEAR_SECONDS}`, 'SameSite=Lax'];
    // A parent-domain cookie is only settable from a host under that domain; localhost gets a host-only cookie
    if (hostname === SHARED_COOKIE_DOMAIN || hostname.endsWith(`.${SHARED_COOKIE_DOMAIN}`)) {
        attributes.push(`Domain=${SHARED_COOKIE_DOMAIN}`);
    }
    if (protocol === 'https:') {
        attributes.push('Secure');
    }
    document.cookie = attributes.join('; ');
}
